import { useDisplaySettings } from '@src/providers/DisplaySettingsProvider';
import { getGroupedColumnColId, type MobileGroupCardRendererProps } from '@talos/kyoko';
import { MobileBlotterGroupCard, resolveGroupMetricCell } from '../MobileBlotterCardLayout';
import { resolveVisiblePositionMetric } from './mobilePositionMetric';

/**
 * Default group row renderer for the mobile positions blotter.
 *
 * Compact single-row layout: chevron · group value · home-currency position.
 * Values use the grouped column's cell renderer (including when that column is
 * hidden from the grid — row-group fields are often `initialHide`). Falls back
 * to `node.key` only when renderCell returns nothing useful. The position
 * metric is omitted when its column is hidden.
 */
export function MobilePositionGroupCard({ node, api, renderCell }: MobileGroupCardRendererProps) {
  const { homeCurrency } = useDisplaySettings();
  const groupedColumnColId = getGroupedColumnColId(node);
  const groupMetricCell = resolveGroupMetricCell({
    colId: groupedColumnColId,
    fallbackLabel: node.key ?? '',
    renderCell,
  });
  const positionMetric = resolveVisiblePositionMetric(api, renderCell, homeCurrency);

  return (
    <MobileBlotterGroupCard
      node={node}
      testId="mobile-position-group-card"
      groupTestId="mobile-position-group-card-group"
      groupMetricCell={groupMetricCell}
      valueMetric={
        positionMetric
          ? {
              label: positionMetric.label,
              value: positionMetric.value,
              testId: 'mobile-position-group-card-position-usd',
            }
          : null
      }
      showExpandIndicator
    />
  );
}
